// Offers routes
export default [
  {
    path: 'sectors-association',
    name: 'sectors-association',
    redirect: 'sectors-association/index',
    component: () =>
      import(
        /* webpackChunkName: "sectorsAssociation" */ '../views/sectorsAssociation/SectorsAssociation.vue'
      ),
    children: [
      {
        path: 'index',
        name: 'sectorsAssociation',
        meta: {
          tabbable: true,
          tableKeys: ['sectorsAssociation'],
          filterKeys: ['sectorsAssociation'],
          formKeys: [],
          routePermissions: ['locationSectorDepartmentView'],
        },
        component: () =>
          import(
            /* webpackChunkName: "sectorsAssociationIndex" */ '../views/sectorsAssociation/SectorsAssociationIndex.vue'
          ),
      },
    ],
  },
];
